<template>
	<div class="text-center">
		<div style="font-size: 0.85rem !important">
			Progress {{ visualizationMainProgress }} dari 2
		</div>

		<div class="mt-2 font-weight-bolder" v-if="visualizationMainProgress === 1">
			Penyiapan Permintaan Data : {{ preparingRequestNumbers }} /
			{{ maxPreparingRequest }}
		</div>
		<div
			class="mt-2 font-weight-bolder"
			v-else-if="visualizationMainProgress === 2"
		>
			Memuat data dari server : {{ dataOutputNumbers }} /
			{{ maxPreparingRequest }}
		</div>

		<b-progress
			class="mt-4"
			:max="maxPreparingRequest"
			variant="success"
			height="1.5rem"
			animated
			v-if="visualizationMainProgress === 1"
		>
			<b-progress-bar
				:value="preparingRequestNumbers"
				:label-html="`<span class='font-weight-bold text-right pr-2' style='font-size: 0.95rem !important;'>${(
					(preparingRequestNumbers / maxPreparingRequest) *
					100
				).toFixed(2)}%	</span>`"
			>
			</b-progress-bar>
		</b-progress>
		<b-progress
			class="mt-4"
			:max="maxPreparingRequest"
			variant="success"
			height="1.5rem"
			animated
			v-else-if="visualizationMainProgress === 2"
		>
			<b-progress-bar
				:value="dataOutputNumbers"
				:label-html="`<span class='font-weight-bold text-right pr-2' style='font-size: 0.95rem !important;'>${(
					(dataOutputNumbers / maxPreparingRequest) *
					100
				).toFixed(2)}%	</span>`"
			>
			</b-progress-bar>
		</b-progress>
	</div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import services from "../../../../../services/TabelDinamisServicesV3.js";
import utils from "../../../../../utils/TabelDinamisUtils.js";

//local registration for output component
export default {
	name: "VisualizationDataRequesting",
	data() {
		return {
			visualizationMainProgress: null,
			maxPreparingRequest: 0,
			dataOutputNumbers: 0,
		};
	},
	props: [
		"selectedDataList",
		"isStep2",
		"requestList",
		"dimensions",
		"maxCategoryRequestNumber",
		"dataOutput",
		"assignDataOutput",
		"resetDataOutput",
		"setDisabledStep1",
		"isPreparingRequesting",
		"rowFields",
		"columnFields",
		"resetRowFields",
		"resetColumnFields",
	],
	created() {},
	destroyed() {},
	mounted: function () {},
	computed: {
		preparingRequestNumbers() {
			let count = 0;

			this.requestList.forEach((item) => {
				count += Object.keys(item.combinationList).length;
			});

			return count;
		},
	},
	watch: {
		isStep2: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal && newVal) {
					this.$emit("update:isPreparingRequesting", true);

					this.setDisabledStep1(true);
					this.visualizationMainProgress = 1;
				}
			},
			immediate: true,
		},
		visualizationMainProgress: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					if (newVal === 1) {
						setTimeout(
							function () {
								this.setMaxPreparingRequest();
								this.setDimensions();
								this.initializeRowFields();
								this.initializeColumnFields();
								this.setRequestList();
							}.bind(this),
							500
						);
					}
				}
			},
			immediate: true,
		},
		preparingRequestNumbers: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					if (
						this.maxPreparingRequest > 0 &&
						newVal === this.maxPreparingRequest
					) {
						setTimeout(
							function () {
								this.visualizationMainProgress = 2;

								this.resetDataOutput();

								this.getDatamart();
							}.bind(this),
							1250
						);
					}
				}
			},
			immediate: true,
		},
		dataOutput: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					if (newVal.length === 0) {
						this.dataOutputNumbers = 0;
					} else if (newVal.length > 0) {
						let count = 0;
						this.dataOutput.forEach((item) => {
							count += Object.keys(item).length;
						});
						this.dataOutputNumbers = count;
					}

					if (newVal.length === this.selectedDataList.length) {
						this.setDisabledStep1(false);
						setTimeout(
							function () {
								this.$emit("update:isPreparingRequesting", false);
							}.bind(this),
							5000
						);
					}
				}
			},
			deep: true,
		},
	},
	methods: {
		setMaxPreparingRequest() {
			this.maxPreparingRequest = 0;

			this.selectedDataList.forEach((item) => {
				let combinationCountEstimation =
					item.selectedIndicator.length * item.selectedPeriod.length;

				item.selectedDimension.forEach((item2) => {
					combinationCountEstimation *= item2.selectedItemDimension.length;
				});

				this.maxPreparingRequest += combinationCountEstimation;
			});

			// return Promise.resolve();
		},
		setDimensions() {
			this.selectedDataList.forEach((item) => {
				let dimension = {};

				let indicator = this.mapADimension(
					item.selectedIndicator,
					"indicator",
					"indikator",
					"id",
					"name"
				);
				dimension = { ...dimension, ...indicator };

				let period = this.mapADimension(
					item.selectedPeriod,
					"period",
					"periode",
					"periodKey",
					"periodName"
				);
				dimension = { ...dimension, ...period };

				let lastestColumnOrder = 0;
				item.selectedDimension.forEach((item2) => {
					if (item2.role.toLowerCase() === "region") {
						let region = this.mapADimension(
							item2.selectedItemDimension,
							"region",
							"wilayah",
							"id",
							"name"
						);
						dimension = { ...dimension, ...region };
					} else if (item2.role.toLowerCase() === "dimension") {
						lastestColumnOrder = item2.columnOrder - 1;

						let category = this.mapADimension(
							item2.selectedItemDimension,
							"category" + lastestColumnOrder,
							item2.name,
							"id",
							"name"
						);
						dimension = { ...dimension, ...category };
					}
				});

				//assign no category-dimension (1-5)
				for (
					let index = lastestColumnOrder + 1;
					index <= this.maxCategoryRequestNumber;
					index++
				) {
					let category = {
						["category" + index]: {
							name: "",
							selectedItem: [],
						},
					};
					dimension = { ...dimension, ...category };
				}

				let dimensions = this.dimensions;
				dimensions.push(dimension);
				this.$emit("update:dimensions", dimensions);
			});

			// return Promise.resolve();
		},
		mapADimension(selectedItem, dimensionKey, dimensionName, idKey, nameKey) {
			return {
				[dimensionKey]: {
					name: dimensionName,
					selectedItem: selectedItem.map((item2) => {
						return {
							id: item2[idKey],
							name: utils.capitalizeEachWord(item2[nameKey]),
						};
					}),
				},
			};
		},
		setRequestList() {
			this.dimensions.forEach((dimension, idx) => {
				let combinationList = {},
					itemCombination = {},
					dimensionItemsIdOnly = [],
					dimensionKeys = Object.keys(dimension);

				itemCombination.datasetId =
					"" + this.selectedDataList[idx].selectedDataset.id;

				//set dimensionItemsIdOnly
				dimensionKeys.forEach((key) => {
					let itemsId = dimension[key].selectedItem.map((item) => item.id);

					if (itemsId.length < 1) {
						itemsId.push(0);
					}

					dimensionItemsIdOnly.push(itemsId);
				});

				//declare recursive construct combination
				function getCombination(array, prefix) {
					prefix = prefix || "";

					if (!array.length) {
						return prefix.slice(0, -1);
					}

					var result = array[0].reduce(function (result, value) {
						return result.concat(
							getCombination(array.slice(1), prefix + value + ",")
						);
					}, []);

					return result;
				}

				let combinationOutput = getCombination(dimensionItemsIdOnly);

				let i = 0;
				Object.values(combinationOutput).forEach((item) => {
					let splittedItem = item.split(",");

					Object.keys(splittedItem).forEach((key) => {
						if (dimensionKeys[key] === "region") {
							let region = {
								regionId: splittedItem[key],
							};
							itemCombination = { ...itemCombination, ...region };
						} else if (dimensionKeys[key] === "indicator") {
							let indicator = {
								indicatorId: splittedItem[key],
							};
							itemCombination = { ...itemCombination, ...indicator };
						} else if (dimensionKeys[key] === "period") {
							let period = {
								period: splittedItem[key],
							};
							itemCombination = { ...itemCombination, ...period };
						} else if (dimensionKeys[key].startsWith("category")) {
							let prefix =
								"itemCategoryId" +
								dimensionKeys[key].slice(dimensionKeys[key].length - 1);

							let category = {
								[prefix]: splittedItem[key],
							};
							itemCombination = { ...itemCombination, ...category };
						}
					});

					combinationList[i] = itemCombination;
					i++;
				});

				let itemCombinationList = {
					combinationList: combinationList,
				};

				this.addToRequestList(itemCombinationList, idx + 1);
			});
		},
		addToRequestList(val, i) {
			setTimeout(
				function () {
					this.requestList.push(val);
				}.bind(this),
				250 * i
			);
		},
		getDatamart() {
			this.requestList.forEach((item, idx) => {
				setTimeout(
					function () {
						this.requestDatamart(item, idx);
					}.bind(this),
					250 * (idx + 1)
				);
			});
		},
		async requestDatamart(item, idx) {
			await services.getODWAgregat(item).then(
				(response) => {
					if (Object.keys(response.data.error).length > 0) {
						let i = Object.keys(response.data.data).length;
						Object.keys(response.data.error).forEach((key) => {
							if (key !== "link") {
								let itemCombinationList =
									response.data.error[key].detail.itemCombinationList;

								let temp = {
									period: itemCombinationList.period,
									indicator: {
										indicatorId: parseFloat(itemCombinationList.indicatorId),
										indicatorName: null,
										dimDataset: {
											datasetId: parseFloat(itemCombinationList.datasetId),
											datasetName: null,
										},
									},
									region: {
										categoryId: null,
										categoryName: null,
										itemCategoryId: parseFloat(itemCombinationList.regionId),
										itemCategoryCode: null,
										itemCategoryName: null,
										levelItem: null,
									},
									value: "...",
									flag: null,
								};

								Object.keys(itemCombinationList).forEach((key2) => {
									if (key2.startsWith("itemCategory")) {
										let id = key2.slice(key2.length - 1);

										let detailItemCategory = {
											categoryId: null,
											categoryName: null,
											itemCategoryId: parseFloat(
												itemCombinationList["itemCategoryId" + id]
											),
											itemCategoryCode: null,
											itemCategoryName: null,
											levelItem: null,
										};

										temp["itemCategory" + id] = {
											...temp["itemCategory" + id],
											...detailItemCategory,
										};
									}
								});

								response.data.data[i] = temp;
								i++;
							}
						});
					}

					// if (Object.keys(response.data.error).length > 0) {
						this.setDatumUniqueKey(response.data.data);
						this.assignDataOutput(response.data.data, idx);
					// }
				},
				(error) => {
					this.data =
						(error.response && error.response.data) ||
						error.message ||
						error.toString();
				}
			);
		},
		initializeRowFields() {
			let rowFields = this.rowFields;
			Object.keys(this.selectedDataList).forEach((key) => {
				rowFields[key] = ["region"];
			});
			this.$emit("update:rowFields", rowFields);
		},
		initializeColumnFields() {
			let columnFields = this.columnFields;
			Object.keys(this.selectedDataList).forEach((key) => {
				columnFields[key] = ["indicator"];
				columnFields[key].push("period");

				let dimension = this.dimensions[key];
				Object.keys(dimension).forEach((key2) => {
					if (
						key2.startsWith("category") &&
						dimension[key2].selectedItem.length > 0
					) {
						columnFields[key].push(key2);
					}
				});
			});

			this.$emit("update:columnFields", columnFields);
		},
		setDatumUniqueKey(data) {
			Object.values(data).forEach((item) => {
				//indicator-period-region-itemCategory[1-5]
				let key =
					"" +
					item.indicator.indicatorId +
					item.period +
					item.region.itemCategoryId +
					item.itemCategory1.itemCategoryId +
					item.itemCategory2.itemCategoryId +
					item.itemCategory3.itemCategoryId +
					item.itemCategory4.itemCategoryId +
					item.itemCategory5.itemCategoryId;
				item["key"] = key;
			});
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 12-09-2022 -->
